import React from 'react';

export default function Pagination({ page, pageSize, total, onPageChange }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const canPrev = page > 1;
  const canNext = page < pages;
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="text-sm text-gray-600 dark:text-gray-300">Página {page} de {pages} • {total} registros</div>
      <div className="flex items-center gap-2">
        <button className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 disabled:opacity-50" disabled={!canPrev} onClick={() => onPageChange(page - 1)}>Anterior</button>
        <button className="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 disabled:opacity-50" disabled={!canNext} onClick={() => onPageChange(page + 1)}>Siguiente</button>
      </div>
    </div>
  );
}
